module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "d7e332837"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c5_r1#d6e4",
      "id": "d7e4"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 3")])]), _c('br'), _c('br'), _c('b', [_vm._v("Individuality ")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e333637"
    }
  }, [_vm._v("Whatever crushes individuality is despotism, whether it professes to be enforcing the will of God or the injunctions of men.")]), _vm._v(" "), _c('p', {
    staticClass: "extr",
    attrs: {
      "id": "d7e334937"
    }
  }, [_vm._v("—John Stuart Mill")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e335437"
    }
  }, [_c('b', [_vm._v("Individuality ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e335937"
    }
  }, [_vm._v("Nothing encapsulates the American Spirit more than individuality. Our Founding Fathers brought into being a nation where individuals are free to choose their own lives and destinies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e337637"
    }
  }, [_vm._v("When Benjamin Franklin was leaving the Constitutional Convention on September 18, 1787, an excited, curious, and anxious crowd met him. Mrs. Powel of Philadelphia asked him, “Well, Doctor, what have we got, a republic or a monarchy?” Franklin’s answer was both hopeful and a warning to Mrs. Powel and the waiting crowd. “A republic, if you can keep it,” he said."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d19",
      "id": "a19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("26")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e341638"
    }
  }, [_vm._v("By rejecting a monarchy—one that would have been easy to sell to a public that had really known nothing else, having been subjects of King George III only a few years earlier, and having a ready-made king in George Washington—the Founding Fathers not only enshrined our liberties in law but also fanned the smoldering embers of our natural individuality to the point that they became a roaring, eternal flame.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e344238"
    }
  }, [_vm._v("The republican form of government had mostly been consigned to the history books since the fall of Rome. Monarchies had ruled the leading powers of the world for centuries. By choosing a republic, where the governed control the government, not the other way around, the Founding Fathers displayed faith in the individual’s ability to know better than any elected or appointed official what is best for himself and his family. The American people, since that day, have justified that faith time and again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e347438"
    }
  }, [_vm._v("Innovation and the entrepreneurial spirit, while possible in other countries, have found a home in the United States. This was no accident. Nick A. Adams, an Australian student of the United States, wrote,")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e348838"
    }
  }, [_vm._v("It may surprise Americans to learn that in many Western cultures, in countries extremely similar to their own, successful people are criticized, resented and targeted. These cultures do not like or reward people whose talents or achievements distinguish them. . . . Being different by exhibiting individuality and independence in these countries is not the way to get ahead in life. Self-promotion is considered the gravest of sins and the poorest of forms. The contrast could not be starker."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d20",
      "id": "a20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("27")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e352739"
    }
  }, [_vm._v("Individuality is the lifeblood of creativity, and nowhere on earth has creativity thrived as it has in America. In part, that’s because “individuality is the aim of political liberty,” James Fenimore Cooper explained. “By leaving to the citizen as much freedom of action and of being, as comports with order and the rights of others, the institutions render him truly a freeman. He is left to pursue his means of happiness in his own manner.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d21",
      "id": "a21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e355839"
    }
  }, [_vm._v("Each person, at each stage of life, is shaped by the dominant social codes and cultural expectations of his environment. In societies with feudal backgrounds, such as those in Europe, with their many-layered class distinctions, a strong set of social expectations represses the individuality of children from an early age. In America, however, things are different and better. Americans are individual and distinct in thinking, in acting, and in expressing their personalities. This expression of individuality is encouraged and rewarded at every level of American society and throughout life. We see this especially in sports and show business, where uniquely talented personalities are some of the most admired and respected people in our society.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e360539"
    }
  }, [_vm._v("“In America,” said Thomas Jefferson, “no other distinction between man and man had ever been known but that of persons in office exercising powers by authority of the laws, and private individuals. Among these last, the poorest laborer stood on equal ground with the wealthiest millionaire, and generally on a more favored one whenever their rights seem to jar.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d22",
      "id": "a22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("28")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e363440"
    }
  }, [_c('b', [_vm._v("From Rags to Riches ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e363940"
    }
  }, [_vm._v("In America it makes no difference where you start out in life; your life is what you make of it. More captains of industry have risen from humble beginnings here than in any other nation on earth. Perhaps the greatest rags-to-riches story in modern history is that of Andrew Carnegie, who went from poverty in Scotland to become one of the richest men in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e366240"
    }
  }, [_vm._v("Carnegie moved to the United States at age thirteen with his family in pursuit of a better life. Andrew worked in a cotton mill earning a mere $1.20 per week in 1848. By 1853 he was earning $4.00 per week working as a telegraph operator for the Pennsylvania Railroad Company where he began to excel and rapidly work his way up the corporate ladder. At that time he began investing in stocks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e368840"
    }
  }, [_vm._v("Through his investments, fueled by his self-education, Carnegie formed the Carnegie Steel Company. Thanks to his innovations in the production of steel, his company grew exponentially. In 1901 he sold the Carnegie Steel Company to J. P. Morgan for the staggering sum of $480 million, and the company became US Steel.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e371440"
    }
  }, [_vm._v("At the time of the sale Andrew Carnegie was the second-richest man in the world—not bad for a poor immigrant boy. He spent the rest of his life engaged in some of the greatest philanthropy the world has ever seen, giving away his fortune to found and fund libraries, universities, and philanthropic ventures around the world. The ultimate self-starter, Carnegie said, “People who are unable to motivate themselves must be content with mediocrity, no matter how impressive their other talents.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("29")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e375341"
    }
  }, [_vm._v("Americans are encouraged to follow their hearts and fulfill their dreams, and those dreams are as diverse as each person. Whether someone attains her dreams remains up to her, but the ability to aspire, coupled with the possibility of achieving her aspirations, remains a major driving force behind the American Spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e377841"
    }
  }, [_vm._v("The old saw that parents tell their children, “You can grow up to be anything you want,” is uniquely American. Until the founding of the United States the odds of a person rising from the lowest to the highest station in life were virtually nil, with the exception of those rising and seizing power through military means. But in America that saying is true.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e380141"
    }
  }, [_vm._v("Starting with Andrew Jackson, who was born into poverty, was orphaned during the Revolutionary War, and rose to become commander of American forces at the Battle of New Orleans, and eventually the seventh president of the United States, we have a history of individuals overcoming the odds to achieve great things. In recent history, two of the last five US presidents—Ronald Reagan and Bill Clinton—rose from poverty to lead the most powerful nation on earth. In his 1981 Inaugural Address, Reagan said, “I do not believe in a fate that will fall on us no matter what we do. I do believe in a fate that will fall on us if we do nothing.” Reagan wasn’t talking about his amazing journey from poverty to 1600 Pennsylvania Avenue, but he might have been.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e384942"
    }
  }, [_vm._v("Luck is an important ingredient of any success, but luck alone will not carry anyone through to victory.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e385942"
    }
  }, [_c('b', [_vm._v("The Individual Spirit ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e386442"
    }
  }, [_vm._v("Anyone who has achieved greatness on any level will tell you that his success was not an accident, not simply luck, but a product of hard work combined with opportunity and experience. No matter how similar their circumstances or accomplishments, no two people ever take the same path through life. The unique experiences we live through shape our individual characters.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e388742"
    }
  }, [_vm._v("How we deal with failure is as important as how we deal with success. Where many would be discouraged by failure, the truly successful are not deterred. Thomas Edison, perhaps the most prolific inventor in world history, when asked about his many failed attempts to create an electric light bulb reportedly said, “I have not failed, I’ve just found ten thousand ways that won’t work.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e390842"
    }
  }, [_vm._v("That attitude is distinctly American. Edison eventually did create his light bulb and hundreds of other inventions. His perseverance was rewarded. “Many of life’s failures are people who did not realize how close they were to success when they gave up,” Edison said on the subject.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e392842"
    }
  }, [_vm._v("With rare exceptions like the printing press, the greatest innovations, inventions, and discoveries in human history have come since the founding of the United States and in the United States. The power of the individual inspires human beings. When that individuality is stifled by government, when government controls the individual, creativity slows and goes underground.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e394942"
    }
  }, [_vm._v("Unfortunately, government naturally tends to expand its own power. This expansion necessarily comes at the price of individual liberty and, therefore, the price of creativity. But government cares little if creativity suffers; it perpetually seeks more control, more power. And growing government power means more power to interfere with, to have influence or control over, more and more of a citizen’s life.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("31")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e398043"
    }
  }, [_vm._v("The Founders were quite aware of government’s tendency to interfere in the lives, work, business, and finances of others. They designed the Constitution with strict prohibitions on the busybodies and meddlers, especially those who got into public office or positions of authority. They established strict checks and balances in the executive, the legislative, and the judicial branches of government to protect the average person from the arbitrary opinions and impositions of others.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e401143"
    }
  }, [_c('b', [_vm._v("The Constrained Vision ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e401643"
    }
  }, [_vm._v("One of the most important formative influences in the lives of the Founding Fathers and the debates over the Declaration of Independence and Constitution was the acknowledgment of human nature and natural law. The Founding Fathers believed that there were certain unalterable characteristics of people and society and that a proper system of governance had no choice but to accept them and provide for them in the laws.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e404243"
    }
  }, [_vm._v("This approach strongly contradicted the idea that human beings were like lumps of clay that could be shaped and formed by government policy. Indifference to the fundamental nature of people led ultimately to the emergence of totalitarianism and to the illusion that government edicts could create a “new man.” Dictators and tyrants were convinced they could force people to become passive, compliant members of a vast human collective. Ideas of unlimited state power have been totally discredited today, especially by the testimonies of people who were made to live under real socialism and know how horrible it really was. They survive today mainly in such intellectual and political backwaters as North Korea and Cuba. Curiously they also are alive and well on many American campuses, where a reactionary professoriate desperately clings to the Marxist clichés and illusions of an earlier era.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("32")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e410544"
    }
  }, [_vm._v("Our approach to human nature is based on what economist and social philosopher Thomas Sowell calls “the constrained vision.” This approach to human affairs recognizes “the moral limitations of man in general, and his egocentricity in particular.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d23",
      "id": "a23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" The Founders had a constrained vision of humanity’s potential, brilliantly summarized by James Madison in "), _c('i', [_vm._v("Federalist ")]), _vm._v("51: “If men were angels, no government would be necessary. If angels were to govern men, neither external nor internal controls on government would be necessary.” But men are not angels. Human beings are motivated by a variety of emotions, including greed, envy, ambition, self-interest, impatience, and desire for personal gain. This fundamental constraint never changes. Instead of trying to modify or reshape the basic qualities of human nature, the Founding Fathers set up a system within which self-interested individuals would have to compete and cooperate with others to achieve their goals.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e416644"
    }
  }, [_vm._v("America is great because the foundations of American exceptionalism and American individualism are built into the fabric of our nation. The Founders held a vision of an America made up of an unlimited number of individuals who would come together, within a framework of law, order, and good government, to create a nation that would be unique in all the history of the world. They summarized this in the motto "), _c('i', [_vm._v("E Pluribus Unum")]), _vm._v(", which means “out of many—one.” The unique characters, personalities, talents, and abilities of all these people would form a single nation that would be truly universal, open to all mankind.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("33")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e421245"
    }
  }, [_c('b', [_vm._v("Adversity and Individuality ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e421745"
    }
  }, [_vm._v("The late author and paleontologist Stephen Gould once said, “I am somehow less interested in the weight and convolutions of Einstein’s brain than in the near certainty that people of equal talent have lived and died in cotton fields and sweatshops.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d24",
      "id": "a24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Gould’s observation is undoubtedly true. Throughout history, many gifted people have been crushed by misfortune and never had the opportunity to exercise their talents. What separates success from failure is how an individual transcends the circumstances that confront him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e425345"
    }
  }, [_vm._v("Richard Nixon lost the presidential election in 1960 to John F. Kennedy, then went on to lose his bid for governor of California in 1962. While faced with unimaginable disappointment, Nixon told the press, “You won’t have Nixon to kick around anymore.” Discouraged by two successive losses, he planned to return to private life and put the prospect of public rejection behind him forever. But his unique personal qualities would not allow him simply to fade away, and he returned to public life and was elected president in 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e428545"
    }
  }, [_vm._v("Although his presidency ended in disgrace, Nixon never did fade away. He spent his life writing books, giving speeches, and influencing public policy and debate. Something inside him wouldn’t accept where he was; he wanted to do more and to be more.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("34")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e430946"
    }
  }, [_vm._v("The history of the United States is filled with stories of individuals overcoming adversity that, had they lived elsewhere in the world, would have held them captive in the circumstances into which they were born.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e432546"
    }
  }, [_vm._v("Jim Abbott, like many boys, loved baseball. But Jim was different. Born in Flint, Michigan, in 1967, he seemed unlikely to grow and play Little League baseball, let alone make it to the major leagues. Jim was born without a right hand, so playing a sport that required every appendage seemed a bridge too far to be realized. Someone forgot to convince Jim of that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e434846"
    }
  }, [_vm._v("Jim "), _c('i', [_vm._v("wanted ")]), _vm._v("to play baseball and be a pitcher, so he set about practicing. He developed a system by which he could deliver a pitch and have his glove in a ready position by the time the ball crossed the plate. Jim was good. He was so good, in fact, that he was drafted out of high school by the Toronto Blue Jays, but instead opted for college at the University of Michigan. While at the university, Jim led the Wolverines to two Big Ten championships, and he was the first baseball pitcher to be awarded the James E. Sullivan Award as amateur athlete of the year in 1987. It was a major accomplishment for anyone, let alone someone with only one hand. But Jim wasn’t finished yet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e439146"
    }
  }, [_vm._v("After his amazing college career, Jim was drafted in the first round by the California Angels and spent the next ten years living out the dream of every little boy who ever played on a sandlot. What’s more, Jim joined the exclusive club of pitchers who have ever thrown a no-hitter when, in 1993, he blanked the Cleveland Indians.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("35")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e441847"
    }
  }, [_vm._v("When you first hear his story, without being told that Jim Abbott was born with only one hand, you would never know it, never even think it. But once the surprise of his story wears off, it gives way to an acknowledgment that it makes perfect sense because Jim Abbott is an American and America is all about amazing stories.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e444147"
    }
  }, [_vm._v("Each story of an individual seizing the opportunities presented to him or creating his own opportunities through his choices is a testament to a nation that values individual liberty and ingenuity. Only in a society that values the individual will someone like Clarence Thomas—a descendant of slaves, born into poverty and segregation—have the opportunity to become an associate justice of the Supreme Court of the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e446747"
    }
  }, [_c('b', [_vm._v("Individuality Under Siege ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e447247"
    }
  }, [_vm._v("In recent years, however, government policy has focused on the needs of socially disadvantaged groups rather than on individuals. A 2004 Congressional Research Service (CRS) survey of federal affirmative action policies, for example, found some 173 “goals, timetables, set-asides, and quotas” in virtually every area where the federal government hires employees, allocates contracts, dispenses benefits, or enacts regulations. As the Heritage Foundation’s vice president for government relations, Mike Franc, has noted, “The set-asides come in all shapes and sizes—5 percent, 6.9 percent, 8 percent, 10 percent, 12 percent, and even 15 percent.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("36")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e451448"
    }
  }, [_vm._v("And who is eligible to benefit from these provisions? “There are as many answers,” Franc wrote, ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d9t00048"
    }
  }, [_vm._v("as there are federal agencies and statutory schemes. My favorite is the definition of “socially disadvantaged” in the Small Business Administration’s 8(a) program. . . . Groups presumed to be “socially disadvantaged” include: “Black Americans; Hispanic Americans; Native Americans (American Indians, Eskimos, Aleuts, or Native Hawaiians); Asian Pacific Americans (persons with origins from Burma, Thailand, Malaysia, Indonesia, Singapore, Brunei, Japan, China (including Hong Kong), Taiwan, Laos, Cambodia (Kampuchea), Vietnam, Korea, The Philippines, U.S. Trust Territory of the Pacific Islands (Republic of Palau), Republic of the Marshall Islands, Federated States of Micronesia, the Commonwealth of the Northern Mariana Islands, Guam, Samoa, Macao, Fiji, Tonga, Kiribati, Tuvalu or Naru); Subcontinent Asian Americans (persons with origins from India, Pakistan, Bangladesh, Sri Lanka, Bhutan, the Maldive Islands, or Nepal)” and members of other groups as designated by the SBA from time to time.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e458748"
    }
  }, [_vm._v("Got that? Even those with ties to Hong Kong, Taiwan, South Korea and Singapore, which rank among the world’s most affluent and economically free economies, are deemed “socially disadvantaged.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d25",
      "id": "a25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e460548"
    }
  }, [_vm._v("But the new emphasis on group rights is not merely illogical; it is profoundly divisive. Former deputy secretary of education Eugene Hickok has pointed out, “The assertion of group rights involves claims being made by one group against another, which invariably involves inequalities and making distinctions among people. It is an approach to rights which forces people to dwell on what they do not have in common, undermining any deeper sense of community that might come to shape the contours of our politics.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d26",
      "id": "a26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("37")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e464449"
    }
  }, [_vm._v("In a May 2007 interview with ABC’s George Stephanopoulos, then Senator Barack Obama declared that affirmative action “can’t be a quota system and it can’t be something that is simply applied without looking at the whole person, whether that person is black or white or Hispanic, male or female.” He even held out the hope that affirmative action would eventually wither away, becoming “a diminishing tool to achieve racial equality in this society.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e467349"
    }
  }, [_vm._v("Now that an African American occupies the Oval Office, isn’t it time to eliminate the race-based, gender-based, and group-based preferences currently embedded in federal laws? In America, individuality is enshrined in the very fabric of our being. It allows each of us to make what we will of our lives and has been the incubator of the world’s greatest inventions and innovations. Only by returning to our long-standing belief that we are a nation of individuals limited merely by our imaginations, and not by the government, will we continue to reap the harvest of creativity and prosperity that our system is uniquely suited to foster.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dfa30fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feul_9781595553904_epub_c9_r1.vue
// module id = 81
// module chunks = 0